module.exports = __webpack_public_path__ + "static/media/other-expenditure.21b25ef9.svg";